import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationCreateWorkspaceProjectArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation CreateWorkspaceProject(
    $customerId: ID!
    $type: String!
    $name: String
    $briefType: String!
    $workspaceId: ID!
    $briefId: ID
    $url: String
    $projectFolderId: ID
    $customerMultiPromptTemplateId: ID
  ) {
    createWorkspaceProject(
      customerId: $customerId
      type: $type
      name: $name
      briefType: $briefType
      workspaceId: $workspaceId
      briefId: $briefId
      url: $url
      projectFolderId: $projectFolderId
      customerMultiPromptTemplateId: $customerMultiPromptTemplateId
    ) {
      id
    }
  }
`;

type Variables = Pick<
  BackendMutationCreateWorkspaceProjectArgs,
  | 'customerId'
  | 'workspaceId'
  | 'briefId'
  | 'projectFolderId'
  | 'name'
  | 'url'
  | 'customerMultiPromptTemplateId'
> & {
  projectType: BackendMutationCreateWorkspaceProjectArgs['type'];
  brief: { type: BackendMutationCreateWorkspaceProjectArgs['briefType'] };
};
type Result = Pick<BackendProject, 'id'>;

export const createProject = async ({
  customerId,
  projectType,
  brief,
  briefId,
  workspaceId,
  url,
  projectFolderId,
  name,
  customerMultiPromptTemplateId,
}: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      type: projectType,
      briefType: brief.type,
      workspaceId,
      briefId,
      projectFolderId,
      name,
      url,
      customerMultiPromptTemplateId,
    },
  });
  return getSingleProp<Result>(result.data);
};
